// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "http://api.uniteddisposal.trangotechdevs.com:3037/";
const BASE_URL = "https://api.uniteddisposal.trangotechdevs.com/";

const API_URL = BASE_URL + "api/supervisior/";

const INITIAL_TOKEN = "313f8033-74b7-47d1-b137-8999922ef759";

const MAP_API_KEY = 'AIzaSyCRZO4wLEOdv7ZECBG-4KVKh-t1SB7FJC4'
// const MAP_API_KEY = 'AIzaSyApOZ-sPDkX7LlPSsQHvWxn34FOpHbSnYQ'

export { API_URL, BASE_URL, INITIAL_TOKEN, MAP_API_KEY };
